module.exports = __webpack_public_path__ + "img/icon-384x384.53407521.png";